export default {
  install(Vue, { router }) {
    router.addRoutes([
      {
        path: '*',
        component: () => import('./NotFound.vue'),
        props: true,
      },
    ]);
  },
};
